import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const PriceFilter = createAsyncThunk(
  "priceRange/PriceFilter",
  async (filterData, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.FILTERPRODUCT}?${filterData?.name}=${filterData?.Catename}&${filterData?.price}=${filterData?.priceRanges}`
      );
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const PriceFilterSlice = createSlice({
  name: "PriceFilterData",
  initialState: {
    PriceFilterData: [],
    error: null,
  },
  reducers: {
    clearPriceFilterData: (state) => {
      state.PriceFilterData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PriceFilter.fulfilled, (state, action) => {
        state.PriceFilterData = action.payload;
      })
      .addCase(PriceFilter.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});
export const { clearPriceFilterData } = PriceFilterSlice.actions;
export default PriceFilterSlice.reducer;
